module.exports = __webpack_public_path__ + "img/商品详情1-4.db23f0f0.png";